import { filter, map } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'
import { TrackType } from '../../../actions/tracks/trackTypes'

// If a dialed-in presenter is muted and there is more than one dialed-in presenter
export const notifyLocalPresenterWhenMuted$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(TrackType.LOCAL_PARTICIPANT_MUTED, TrackType.LOCAL_PARTICIPANT_UNMUTED),
  filter(() => state$.value.user.BTID !== null &&
    state$.value.room.dialedInParticipants.includes(state$.value.user.BTID) &&
    state$.value.room.dialedInParticipants.length > 1
  ),
  map(({ type }) => trackActions.sendDialInMuteNotification(type === TrackType.LOCAL_PARTICIPANT_MUTED))
)

export default notifyLocalPresenterWhenMuted$
